module.exports = __webpack_public_path__ + "static/media/worker-img2.a5fc2e70.webp";